import { theme } from '../styles/theme';
import React from 'react';

export const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    padding: '40px 24px',
    textAlign: 'center',
    backgroundColor: theme.colors.background.primary,
  },
  icon: {
    fontSize: '56px',
    marginBottom: '16px',
    lineHeight: 1,
  },
  heading: {
    fontSize: '22px',
    fontWeight: '700',
    color: theme.colors.text.primary,
    margin: '0 0 12px',
  },
  message: {
    fontSize: '15px',
    color: theme.colors.text.secondary,
    margin: '0 0 28px',
    maxWidth: '400px',
  },
  buttonRow: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  primaryButton: {
    backgroundColor: theme.colors.primary,
    color: theme.colors.text.white,
    border: 'none',
    borderRadius: '8px',
    padding: '10px 24px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    minHeight: '44px',
    fontFamily: 'inherit',
  },
  secondaryButton: {
    backgroundColor: 'transparent',
    color: theme.colors.text.secondary,
    border: `1px solid ${theme.colors.border.medium}`,
    borderRadius: '8px',
    padding: '10px 24px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    minHeight: '44px',
    fontFamily: 'inherit',
  },
};
